module.exports = __webpack_public_path__ + "img/navigation.68c61d65.png";